import React from "react";
import { cn } from "@/lib/utils";

const PunchCardIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    viewBox="0 0 240 144"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M0 8C0 3.58172 3.58172 0 8 0H14.064H40V72H0V8Z" />
    <path d="M40 0H74C78.4183 0 82 3.58172 82 8V72H40V0Z" />
    <path d="M118 8C118 3.58172 121.582 0 126 0H152C156.418 0 160 3.58172 160 8V64C160 68.4183 156.418 72 152 72H118V8Z" />
    <path d="M0 72H42V136C42 140.418 38.4183 144 34 144H8C3.58172 144 0 140.418 0 136V72Z" />
    <rect x="200" y="72" width="40" height="72" rx="8" />
    <path d="M78 72H122V136C122 140.418 118.418 144 114 144H86C81.5817 144 78 140.418 78 136V72Z" />
    <path d="M42 71.9999C42 71.9999 52.3528 71.9999 50 71.9999C47.6472 71.9999 45.0565 71.7277 43.3977 74.594C41.726 77.4827 42 86.1178 42 89.9999C42 93.8819 42 71.9999 42 71.9999Z" />
    <path d="M78 71.9999C78 71.9999 67.6472 71.9999 70 71.9999C72.3528 71.9999 74.9435 71.7277 76.6023 74.594C78.274 77.4827 78 86.1178 78 89.9999C78 93.8819 78 71.9999 78 71.9999Z" />
    <path d="M82 71.9999C82 71.9999 92.3528 71.9999 90 71.9999C87.6472 71.9999 85.0565 72.272 83.3977 69.4057C81.726 66.517 82 57.8819 82 53.9999C82 50.1179 82 71.9999 82 71.9999Z" />
    <path d="M118 71.9999C118 71.9999 107.647 71.9999 110 71.9999C112.353 71.9999 114.944 72.272 116.602 69.4057C118.274 66.517 118 57.8819 118 53.9999C118 50.1179 118 71.9999 118 71.9999Z" />
    <path d="M122 71.9999C122 71.9999 132.353 71.9999 130 71.9999C127.647 71.9999 125.056 71.7277 123.398 74.594C121.726 77.4827 122 86.1178 122 89.9999C42 93.8819 122 71.9999 122 71.9999Z" />
  </svg>
);

interface PunchCardLogoProps {
  type?: "logo" | "icon" | "favicon";
  size?: "md" | "lg";
  className?: string;
  iconClassName?: string;
}

const sizeConfig = {
  md: { gap: "gap-3", icon: "h-7", iconOnly: "h-5", text: "text-2xl" },
  lg: { gap: "gap-6", icon: "h-14", iconOnly: "h-10", text: "text-5xl" },
};

const PunchCardLogo: React.FunctionComponent<PunchCardLogoProps> = ({
  className,
  iconClassName,
  type = "favicon",
  size = "md",
}) => {
  const s = sizeConfig[size];

  return (
    <div className={cn("flex items-center", s.gap, className)}>
      {type === "favicon" ? (
        <>
          <PunchCardIcon className={cn("w-auto", s.icon, iconClassName)} />
          <span className={cn("font-display mb-0.5 [font-variation-settings:'wdth'_115,'wght'_475]", s.text)}>
            punch.cards
          </span>
        </>
      ) : (
        <PunchCardIcon className={cn("w-auto", s.iconOnly, iconClassName)} />
      )}
    </div>
  );
};

export default PunchCardLogo;

